import React, { useEffect, useState } from "react";
import {
  Table,
  TableLoader,
  TableModel,
} from "../../components/tableLoader/index.js";
import { useSelector } from "react-redux";
import ModalReport from "../../components/modalReport/ModalReport.jsx";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import * as cls from "./selfCheck.module.scss";
import add_attachment from "./api.js";
import { WidgetFrame } from "../../../personal-studio-components/studio/WidgetFrame.jsx";
import { StudentService } from "../../components/studentService/index.js";
export { SelfCheck };

function SelfCheck({}) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [planningId, setPlanningId] = useState(null);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isVkr, setISVkr] = useState("false");
  const [key, setKey] = useState(0);
  const [file, setFile] = useState("");
  const [loadProccess, setLoadProccess] = useState(false);

  const loader = {
    title: "Пробная проверка творческой работы",
    icon: "survey",
    request: {
      method: "post",
      path: "/resources/antiplagiat/self_check/list",
      data: {
        access_token,
        study_contract_id: contractId,
        rows: 20,
      },
    },
    parser: createModel,
  };

  function createModel(response) {
    const table = new TableModel(response);
    table.columns.forEach((element) => {
      if (element.field === "upload_file_name") {
        element.type = "html";
      }
      if (element.field === "percent") {
        element.type = "number";
      }
      if (element.field === "upload_date") {
        element.type = "dateTime";
      }
      if (element.field === "report_id") {
        element.type = "link";
      }
    });
    table.rows = table.rows.map((row) => ({
      ...row,
      report_id: !row.report_id
        ? null
        : {
            name: "Открыть",
            href: "#" + row.report_id,
            onClick: (link) => {
              setIsShowModal(true);
              setPlanningId(row.report_id);
            },
          },
    }));
    return table;
  }

  async function onFileUpload(e) {
    const file = e.target.files[0];
    setFile("");
    const fileData = {
      access_token,
      study_contract_id: contractId,
      source_filename: file.name,
      file,
      is_vkr: isVkr,
      progress_fn: (p) => {
        setLoadProccess(p);
      },
    };
    try {
      const { guid, file_name, mime_type } = await add_attachment(fileData);
      const request = {
        method: "post",
        path: "/resources/antiplagiat/self_check/check",
        data: {
          access_token,
          study_contract_id: contractId,
          guid,
          upload_file_name: file_name,
          is_vkr: isVkr === "true",
        },
      };
      await StudentService.send(request, (response) => {});
      setKey((prev) => prev + 1);
      setLoadProccess(false);
    } catch (error) {
      setLoadProccess(false);
    }
  }

  async function onChange(e) {
    setISVkr(e.target.value);
  }

  return (
    <>
      <WidgetFrame title="Загрузка файла" icon="survey">
        <FormControl>
          <label>Выберите тип загружаемого файла</label>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue={false}
            name="radio-buttons-group"
            onChange={onChange}
          >
            <FormControlLabel
              value={false}
              control={<Radio />}
              label="Творческая работа"
            />
            <FormControlLabel value={true} control={<Radio />} label="ВКР" />
          </RadioGroup>
        </FormControl>
        <input
          className={cls.inputHiden}
          id="input__file"
          value={file}
          type="file"
          onChange={onFileUpload}
        />

        <label className={cls.inputlabel} htmlFor="input__file">
          {loadProccess ? loadProccess + "%" : "Загрузить"}
        </label>
        {isShowModal && (
          <ModalReport
            planningId={planningId}
            setIsShowModal={setIsShowModal}
          />
        )}
      </WidgetFrame>
      <TableLoader {...loader} key={key} />
    </>
  );
}
